import React, { useState, useEffect} from 'react';
//import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";
import AxiosFetchData from '../pages/AxiosFetchData';
 
export default function ResponseDialog({message, setmessage,tipe,settipe}) {
    
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    var myTimeout;
    useEffect(() => {
        if(message && message !=''){
          clearTimeout(myTimeout);
            setOpen(true);
          
            if(tipe && tipe=='errorlog'){
              WriteLog();
            }
        }
    }, [message,tipe]);
 

    const WriteLog = async () =>{
      try{
        var data = {
          query: `
           mutation {
              writelog(message : "${message}") {
                msg,
               }
              },
            `
          }
  
          await AxiosFetchData.post('graphql', data).refreshToken(navigate);
      }catch(err){

      }
     
    }
     
    const handleClose = (event, reason) => {
       
      if (reason === 'clickaway') {
        return;
      }
      setOpen(false);
      
      myTimeout = setTimeout(function() {
        setmessage(null);
       
        if(tipe){
          if(settipe){
            settipe(null)
          }
         
        }
       
      }, 100);
    };
  
    return (
      <div>
        
        <Snackbar open={open} autoHideDuration={3000} onClose={handleClose}
         anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}>
          <Alert
            onClose={handleClose}
            severity={tipe == 'error' || tipe =='errorlog' ? "error" : "success"}
            variant="filled"
            sx={{ width: '100%',fontSize: 15 }}
           
          >
            <div dangerouslySetInnerHTML={{__html: message ?  message : ""}}></div>
           {/* {message ?  message : ""} */}
          </Alert>
        </Snackbar>
      </div>
    );
}